import React from 'react';
import { Create, SimpleForm, FileInput, ImageField, useCreate, useNotify, useRedirect, Toolbar, SaveButton, required } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

function ProyectosCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'plg-proyectoss';

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      
      if (!data.portada?.rawFile) {
        notify('La portada es obligatoria', { type: 'warning' });
        return;
      }

      const fileUploaded = await uploadImage(data.portada.rawFile, token!);
      const payload = {
        descripcion: data.descripcion,
        portada: { id: fileUploaded.id },
      };

      create(resourceName, { data: payload }, {
        onSuccess: () => {
          notify('Proyecto creado', { type: 'success' });
          redirect('list', resourceName);
        }
      });
    } catch (e) {
      notify('Error al crear proyecto', { type: 'error' });
    }
  };

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <RichTextInput 
          source="descripcion" 
          label="Descripción del Proyecto"
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
        <FileInput source="portada" label="Imagen de Portada" validate={[required()]}>
          <ImageField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
}

export default ProyectosCreate;